import api from '../../services/api';
import { conversationRequestTimeoutMs } from '../../constant/crm/crm.conversation.constant';

const baseUrl = 'crm/opportunity'

const findById = (opportunityId) =>
    api.get({ service: `${baseUrl}/${opportunityId}` });

const findDetailsById = (opportunityId) =>
    api.get({ service: `${baseUrl}/${opportunityId}/details` });

const request = async (values) =>
    api.post({ service: `${baseUrl}/request`, data: values });

const createFromReferral = async (values) =>
    api.post({ service: `crm/contact/referral`, data: values });

const update = (id, data) =>
    api.put({ service: `${baseUrl}/${id}`, data });

const lose = (id, data) =>
    api.put({ service: `${baseUrl}/${id}/lose`, data });

const schedule = (id, data) =>
    api.post({ service: `${baseUrl}/${id}/schedule`, data });

const cancelSchedule = (id, data) =>
    api.remove({ service: `${baseUrl}/${id}/schedule`, data: { data } });

const concludeSchedule = (id, data) =>
    api.put({ service: `${baseUrl}/${id}/schedule/conclude`, data });

const remove = (id, data) =>
    api.remove({ service: `${baseUrl}/${id}`, data: { data } });

const findByFilter = (filters, pagination) =>
    api.post({ service: `${baseUrl}/filter`, data: { filters, pagination } });

const findFilters = () =>
    api.get({ service: `${baseUrl}/list-filters` });

const findOperationConfig = () =>
    api.get({ service: `${baseUrl}/operation-config` });

const findOrbitaConversation = (opportunityId) =>
    api.get({
        service: `${baseUrl}/${opportunityId}/orbita-conversation`,
        additionalConfigs: { timeout: conversationRequestTimeoutMs },
    });

const findOrbitaHistory = (opportunityId) =>
    api.get({ service: `${baseUrl}/${opportunityId}/orbita-history` });

const registerOrbitaSentMessage = (opportunityId, data) =>
    api.post({ service: `${baseUrl}/${opportunityId}/orbita-sent-message`, data });

const assume = (opportunityId) =>
    api.post({ service: `${baseUrl}/${opportunityId}/assume` });

export default {
    findById,
    findDetailsById,
    request,
    createFromReferral,
    update,
    lose,
    schedule,
    cancelSchedule,
    concludeSchedule,
    remove,
    findByFilter,
    findFilters,
    findOperationConfig,
    findOrbitaConversation,
    findOrbitaHistory,
    registerOrbitaSentMessage,
    assume
}
